module.exports = __webpack_public_path__ + "img/gift4-01-c08-y2.802a474f.png";